/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent, useCallback} from 'react';
import {makeStyles} from '@material-ui/core';
import {Link} from '@ion/core/src/types/entities';

export interface DeviceTitleProps {
  devices?: Link[];
  onDeviceClick?: Function;
}

const useStyles = makeStyles(() => ({
  deviceSections : {
    display       : 'flex',
    alignItems    : 'center',
    letterSpacing : '0.4px'
  },
  deviceName : {
    cursor         : 'pointer',
    textDecoration : 'underline'
  }
}));

/**
 * Defines the DeviceTitle component. This component is used to
 * display the device names with tooltip when we click on more device link
 *
 * ```typescript
 *
 *   import DeviceTitle from './DeviceTitle';
 *
 *   <DeviceTitle  devices={devices} />
 *
 * ```
 */
const DeviceTitle = ({
  devices,
  onDeviceClick
}: DeviceTitleProps) => {
  const classes      = useStyles();
  const deviceLength = devices?.length;

  const onDeviceTitleClick = useCallback((device: Link) => (e: MouseEvent<HTMLDivElement>) => {
    onDeviceClick(device);
  }, [onDeviceClick]);

  if (deviceLength) {
    return (
      <>
        {devices?.slice(1).map(device => {
          return (
            <div className={classes.deviceSections}
              onClick={onDeviceTitleClick(device)}>
              <span className={classes.deviceName}>{device?.title}</span>
            </div>
          );
        })}
      </>
    );
  }
  return <div />;
};

export default React.memo(DeviceTitle);
